import {useEffect} from 'react';
import type {IBreadcrumbItem} from '@fluentui/react';

const APP_TITLE = 'TR:ACE';
const SEPARATOR = ' · ';
const MISSING_VALUES = ['', 'undefined', 'null'];

let activeWriters = 0;

/** Sets the tab title from `segments` (reversed, " · "-joined) + app name; restores it on unmount. */
export function useDocumentTitle(
	segments: (string | false | null | undefined)[],
): void {
	const label = segments.filter(Boolean).reverse().join(SEPARATOR);
	const title = label ? `${label}${SEPARATOR}${APP_TITLE}` : APP_TITLE;

	useEffect(() => {
		document.title = title;
		return () => {
			document.title = APP_TITLE;
		};
	}, [title]);

	useEffect(() => {
		if (process.env.NODE_ENV === 'production') return;
		activeWriters += 1;
		if (activeWriters > 1) {
			console.warn(
				'useDocumentTitle: competing browser-tab-title writers are active at once — only one page should set the title; it is now nondeterministic.',
			);
		}

		return () => {
			activeWriters -= 1;
		};
	}, []);
}

/** Drives the tab title from a page's breadcrumb items, skipping any still loading. */
export function useDocumentTitleFromBreadcrumbs(
	items: IBreadcrumbItem[],
): void {
	useDocumentTitle(
		items.map(item => item.text).filter(text => !MISSING_VALUES.includes(text)),
	);
}
